import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface InfoTooltipProps {
  text: string;
  className?: string;
  iconClassName?: string;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  text,
  className,
  iconClassName,
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span
        className={cn('inline-flex items-center justify-center', className)}
        aria-label={text}
        tabIndex={0}
        onClick={(event) => event.stopPropagation()}
        onPointerDown={(event) => event.stopPropagation()}
      >
        <Info className={cn('h-3.5 w-3.5', iconClassName)} />
      </span>
    </TooltipTrigger>
    <TooltipContent
      side="top"
      className="!bg-black !text-white border-black max-w-xs text-center"
    >
      {text}
    </TooltipContent>
  </Tooltip>
);
